<template>
    <v-layout>
         <!-- Apply for PC or Laptop -->
        <v-container class="hidden-sm-and-down">
            <v20a5000pc/>
        </v-container>
        <!-- Apply for Mobile -->
        <v-container class="hidden-md-and-up">
            <v20a5000m/>
        </v-container>
    </v-layout>    
</template>

<script>

import v20a5000m from './popup/v20a5000m'
import v20a5000pc from './popup/v20a5000pc'


export default {
    
    name: "v20a5000",
    components: {
       v20a5000m,
       v20a5000pc 
    },
    props:{
       
    },
    data: () => ({  
       

    }),    
    mounted() {

     
    },
    methods : {

    }

    
}
</script>